export enum UiState {
  Idle = 'IDLE',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
}
